import React from 'react'

const data = [
    { patrouille: 'Patrouille 1', troupe: 'Troupe 1', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 2', troupe: 'Troupe 2', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 3', troupe: 'Troupe 3', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 4', troupe: 'Troupe 4', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 5', troupe: 'Troupe 5', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 6', troupe: 'Troupe 6', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 7', troupe: 'Troupe 7', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 8', troupe: 'Troupe 8', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 9', troupe: 'Troupe 9', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 10', troupe: 'Troupe 10', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 11', troupe: 'Troupe 11', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 12', troupe: 'Troupe 12', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 13', troupe: 'Troupe 13', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 14', troupe: 'Troupe 14', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 15', troupe: 'Troupe 15', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 16', troupe: 'Troupe 16', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 17', troupe: 'Troupe 17', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 18', troupe: 'Troupe 18', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 19', troupe: 'Troupe 19', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 20', troupe: 'Troupe 20', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 21', troupe: 'Troupe 21', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 22', troupe: 'Troupe 22', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 23', troupe: 'Troupe 23', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 24', troupe: 'Troupe 24', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 25', troupe: 'Troupe 25', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 26', troupe: 'Troupe 26', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 27', troupe: 'Troupe 27', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 28', troupe: 'Troupe 28', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 29', troupe: 'Troupe 29', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 30', troupe: 'Troupe 30', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 31', troupe: 'Troupe 31', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 32', troupe: 'Troupe 32', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 33', troupe: 'Troupe 33', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 34', troupe: 'Troupe 34', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 35', troupe: 'Troupe 35', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 36', troupe: 'Troupe 36', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 37', troupe: 'Troupe 37', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 38', troupe: 'Troupe 38', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 39', troupe: 'Troupe 39', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 40', troupe: 'Troupe 40', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 41', troupe: 'Troupe 41', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 42', troupe: 'Troupe 42', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 43', troupe: 'Troupe 43', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 44', troupe: 'Troupe 44', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 45', troupe: 'Troupe 45', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 46', troupe: 'Troupe 46', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 47', troupe: 'Troupe 47', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 48', troupe: 'Troupe 48', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 49', troupe: 'Troupe 49', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 50', troupe: 'Troupe 50', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 51', troupe: 'Troupe 51', district: 'ML3', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 52', troupe: 'Troupe 52', district: 'ML4', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 53', troupe: 'Troupe 53', district: 'ML1', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
    { patrouille: 'Patrouille 54', troupe: 'Troupe 54', district: 'ML2', scores: Array.from({ length: 54 }, () => Math.floor(Math.random() * 100)) },
];

const Test = () => {
    const [search, setSearch] = React.useState('');
    const [groupFilter, setGroupFilter] = React.useState('');
    const [sortConfig, setSortConfig] = React.useState({ key: '', direction: '' });
    const [currentPage, setCurrentPage] = React.useState(1);
    const itemsPerPage = 15;

    const filteredData = data
        .filter(item => 
            item.patrouille.toLowerCase().includes(search.toLowerCase()) ||
            item.troupe.toLowerCase().includes(search.toLowerCase()) ||
            item.district.toLowerCase().includes(search.toLowerCase())
        )
        .filter(item => groupFilter ? item.district === groupFilter : true);

    const sortedData = [...filteredData].sort((a, b) => {
        if (sortConfig.key) {
            if (a[sortConfig.key] < b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? -1 : 1;
            }
            if (a[sortConfig.key] > b[sortConfig.key]) {
                return sortConfig.direction === 'ascending' ? 1 : -1;
            }
        }
        return 0;
    });

    const paginatedData = sortedData.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

    const requestSort = key => {
        let direction = 'ascending';
        if (sortConfig.key === key && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }
        setSortConfig({ key, direction });
    };

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
        <div className="container mx-auto p-4">
            <div className="flex justify-between mb-4">
                <input
                    type="text"
                    placeholder="Search..."
                    value={search}
                    onChange={e => setSearch(e.target.value)}
                    className="border p-2 rounded"
                />
                <select
                    value={groupFilter}
                    onChange={e => setGroupFilter(e.target.value)}
                    className="border p-2 rounded"
                >
                    <option value="">All Groups</option>
                    <option value="ML1">ML1</option>
                    <option value="ML2">ML2</option>
                    <option value="ML3">ML3</option>
                    <option value="ML4">ML4</option>
                </select>
            </div>
            <div className="overflow-x-auto">
                <table className="min-w-full bg-white">
                    <thead>
                        <tr>
                            <th className="py-2 px-4 border" onClick={() => requestSort('patrouille')}>Patrouille</th>
                            <th className="py-2 px-4 border" onClick={() => requestSort('troupe')}>Troupe</th>
                            <th className="py-2 px-4 border" onClick={() => requestSort('district')}>District</th>
                            {Array.from({ length: 54 }, (_, i) => (
                                <th key={i} className="py-2 px-4 border">Round {i + 1}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedData.map((item, index) => (
                            <tr key={index}>
                                <td className="py-2 px-4 border">{item.patrouille}</td>
                                <td className="py-2 px-4 border">{item.troupe}</td>
                                <td className="py-2 px-4 border">{item.district}</td>
                                {item.scores.map((score, i) => (
                                    <td key={i} className="py-2 px-4 border">{score}</td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="flex justify-between mt-4">
                <button
                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                    className="border p-2 rounded"
                >
                    Previous
                </button>
                <span>Page {currentPage} of {totalPages}</span>
                <button
                    onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                    className="border p-2 rounded"
                >
                    Next
                </button>
            </div>
        </div>
    );
};

export default Test